import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { PropTypes as PT } from 'prop-types';
import SVG from 'react-inlinesvg';
import popoutIcon from '@lifesize/ux-assets/vectors/svgIcons/popout.svg';
import classes from './PopoutButton.module.scss';

class PopoutButton extends Component {
  componentDidMount() {
    this.props.unhidePopout();
    setTimeout(() => this.props.onButtonTimeout(), 3000);
  }

  render() {
    const {
      hidePopout,
      isInMiddle,
      onMouseEnter,
      onMouseLeave,
      popoutPresentation,
      position,
      togglePopout
    } = this.props;

    if (hidePopout) return <div />;

    const popoutClasses = [
      classes.popout,
      isInMiddle ? classes.middle : ''
    ].join(' ');

    return (
      <div className={classes.popoutOverlay} style={position}>
        <button
          className={popoutClasses}
          onClick={() => {
            togglePopout(!popoutPresentation);
          }}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          data-testid="popout-presentation-btn"
        >
          <SVG src={popoutIcon} data-testid="popoutIcon" />
          <div className={classes.popoutText}>
            <FormattedMessage
              id="components.popout.popout"
              defaultMessage="Pop Out"
            />
          </div>
        </button>
      </div>
    );
  }
}

PopoutButton.propTypes = {
  hidePopout: PT.bool,
  isInMiddle: PT.bool,
  onButtonTimeout: PT.func,
  onMouseEnter: PT.func,
  onMouseLeave: PT.func,
  popoutPresentation: PT.bool,
  position: PT.object,
  togglePopout: PT.func,
  unhidePopout: PT.func,
};

PopoutButton.defaultProps = {
  onButtonTimeout: () => { },
  unhidePopout: () => { }
};

export default injectIntl(PopoutButton);
